import React from "react";

export default function AdminSortHeading({ stlpec, zoradenie, onSort, children }) {
  const aktivny = zoradenie.stlpec === stlpec;
  return (
    <th aria-sort={aktivny ? (zoradenie.smer === "asc" ? "ascending" : "descending") : "none"}>
      <button type="button" className="admin-sort-btn" onClick={() => onSort(stlpec)}>
        {children} <span className="admin-sort-mark" aria-hidden="true">{aktivny ? (zoradenie.smer === "asc" ? "↑" : "↓") : "↕"}</span>
      </button>
    </th>
  );
}
